var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[( _vm.GET_ORDER_DETAIL_SIGNEDIN_RES!=null)?_c('div',[_c('cBookingStatus',{attrs:{"bookingStatus":_vm.page}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }